import { render, staticRenderFns } from "./CopilotoEvento.vue?vue&type=template&id=4b67577c&"
import script from "./CopilotoEvento.vue?vue&type=script&lang=ts&"
export * from "./CopilotoEvento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4b67577c', component.options)
    } else {
      api.reload('4b67577c', component.options)
    }
    module.hot.accept("./CopilotoEvento.vue?vue&type=template&id=4b67577c&", function () {
      api.rerender('4b67577c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Eventos/CopilotoEvento.vue"
export default component.exports